// extracted by mini-css-extract-plugin
export default {"button":"ResourceSearch_button__1b4_G"};